import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import {OrderFiltersType} from "../../../../../graphql/types/OrderFiltersType";

export const ORDER_FIELDS = `
    id
    securityRnd
    trackingNumber
    channelId
    channelOrderNumber
    orderTime
    overallStatus
    isDelivered
    isIntercepted
    isAbnormal
    exceptionStatus
    expectedDeliveryTime
    deliveredAt
    deliveryAttempts
    exceptionReasonCode
    markExceptionAt
    nextAction
    isHasBeenSetException
    senderAddressId
    recipientAddressId
    receiverZipcode
    sortingCode
    weightKg
    volumetricWeightKg
    lengthCm
    widthCm
    heightCm
    packageValueUsd
    podReviewStatus
    podImageS3KeysJson
    podImageS3UrlsJson
    exceptionImageS3KeysJson
    exceptionImageS3UrlsJson
    nextAction
    exceptionHubId
    exceptionWarehouseId
    isDestHubArrived
    isDestWarehouseArrived
    destHubArrivedAt
    destWarehouseArrivedAt
    receivedAtHub
    deliverAt
    isComplaint
    hasManded
    isFinished
    createdAt
    updatedAt
    warehouseLocationCode
    storageNumber
`;


export const GET_ORDER_LISTING_FOR_WAREHOUSE = gql`
    query WarehouseQuery($filters: OrderFiltersTypeInput,
                         $pageRequest: PageRequestTypeInput) {
        getOrderListingForWarehouse(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${ORDER_FIELDS}
                recipientAddress {
                    id
                    fullName
                    countryCode
                    phoneNumber
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    company
                    instructions
                }
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface WarehouseOrderListResponse {
    getOrderListingForWarehouse: OrderListingResponseType;
}

export interface OrderListingResponseType {
    content: OrderType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface GetOrderListingForWarehouseInput {
    filters?: OrderFiltersType;
    pageRequest?: PageRequestType;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
} 